<template lang="pug">
  span
    el-card.box-card.bg-purple
      .clearfix(slot="header")
        | Αναζήτηση με Επώνυμο:
        el-button(style='float: right; padding: 3px 0', type='text', @click='toggleSearch')| Κλείσιμο
      .text.item
        el-input(placeholder='Επώνυμο', v-model='searchSurname',
          v-on:keyup.enter.native='searchForeignUsers')
        el-button(type='primary', @click='searchForeignUsers', v-popover:popover="", icon="el-icon-search") Αναζήτηση Χρηστών
        el-tooltip(placement='right')
          div(slot='content') Αναζήτηση βάσει 2 ελληνικών ή 4 αγγλικών γραμμάτων
          i.el-icon-question
        template
        el-table(ref="filterTable" stripe border highlight-current-row :data='tableData'
          v-loading='loadingSearchedApplications', @row-click="setForeignUser" :default-sort = "{prop: 'name', order: 'descending'}")
          el-table-column(prop="name" label="Ονομα" sortable='')
          el-table-column(prop="surname" label="Eπώνυμο" sortable='')
          el-table-column(prop="fatherName" label="Πατρώνυμο" sortable='')
          el-table-column(prop="motherName" label="Μητρώνυμο" sortable='')
        <el-dialog title="Στοιχεία Χρήστη" :visible.sync="dialogFormVisible" v-loading='loadingSearchedApplication' width='60%'>
          el-form.ruleForm(:inline='true', :model='userCredentials', status-icon='', ref='userCredentials', label-width='150px', v-loading='savingChanges')
            el-form-item(label='Email', prop='email', size='large')
              el-input.register(type='name', v-model='userCredentials.email', auto-complete='off',
              size='large')
            el-form-item(label='Όνομα', prop='name', size='large')
              el-input.register(type='name', v-model='userCredentials.name', auto-complete='off',
              size='large' @input="userCredentials.name=userCredentials.name.toUpperCase()")
            el-form-item(label='Επώνυμο', prop='surname', size='large')
              el-input.register(type='name', v-model='userCredentials.surname', auto-complete='off',
              size='large' @input="userCredentials.surname=userCredentials.surname.toUpperCase()")
            el-form-item(label='Πατρώνυμο', prop='fatherName', size='large')
              el-input.register(type='name', v-model='userCredentials.fatherName', auto-complete='off',
              size='large' @input="userCredentials.fatherName=userCredentials.fatherName.toUpperCase()")
            el-form-item(label='Μητρώνυμο', prop='motherName', size='large')
              el-input.register(type='name', v-model='userCredentials.motherName', auto-complete='off',
              size='large' @input="userCredentials.motherName=userCredentials.motherName.toUpperCase()")
            el-form-item(label='Κινητό', prop='mobile', size='large')
              el-input.register(type='name', v-model='userCredentials.mobile', auto-complete='off', size='large')
            el-form-item(label='Αριθμός Διαβατηρίου', prop='foreignerId.number', size='large')
              el-input.register(type='name', v-model='userCredentials.foreignerId.number', auto-complete='off', size='large')
            el-form-item(label='Χώρα έκδοσης', prop='foreignerId.country', size='large')
              el-input.register(type='name', v-model='userCredentials.foreignerId.country', auto-complete='off', size='large'
              @input="userCredentials.foreignerId.country=userCredentials.foreignerId.country.toUpperCase()")
            hr
          el-button(type='primary', icon="el-icon-edit",  @click='updateForeigner') Αποθήκευση αλλαγών
          el-button(type='warning', icon="el-icon-message",  @click='resetPasswordForeigner') Επαναφορά κωδικού
        </el-dialog>
</template>

<script>
// import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import dictionary from '../../store/dictionary'
import axios from 'axios'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    dictionary
  },
  props: [],
  mixins: [sharedMethods],
  data () {
    return {
      role: 'fromSearchedApps',
      searchSurname: '',
      activeName: 'second',
      dialogFormVisible: false,
      savingChanges: false
    }
  },
  methods: {
    updateForeigner (ev) {
      this.savingChanges = true
      let dataPut = { userCredentials: this.userCredentials }
      axios.put(`${this.BASE_URL}/foreignusers/${this.userCredentials.id}`, dataPut)
        .then((response) => {
          this.$store.dispatch('LOAD_SEARCHED_FOREIGN_USERS', {surname: this.searchSurname})
          this.$notify.success({
            title: 'Ειδοποίηση',
            message: 'Τα στοιχεία του χρήστη ανανεώθηκαν με επιτυχία',
            offset: 100
          })
          this.savingChanges = false
          this.dialogFormVisible = false
        }).catch(err => {
          this.savingChanges = false
          this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Τροποποίηση')
          this.backendError(err)
        })
    },
    resetPasswordForeigner (ev) {
      this.savingChanges = true
      let dataPut = { userCredentials: this.userCredentials }
      axios.put(`${this.BASE_URL}/foreignusers/${this.userCredentials.id}?reset=password`, dataPut)
        .then((response) => {
          this.$notify.success({
            title: 'Ειδοποίηση',
            message: 'Το Όνομα Χρήστη και ο κωδικός πρόσβασης αρχικοποιήθηκαν με επιτυχία. Έχει σταλεί email με τα καινούρια στοιχεία στο Χρήστη',
            offset: 100
          })
          this.savingChanges = false
          this.dialogFormVisible = false
        }).catch(err => {
          this.savingChanges = false
          this.modifyError(this.userCredentials.name, this.userCredentials.surname, 'Επαναφορά κωδικού')
          this.backendError(err)
        })
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    toggleSearch () {
      this.$store.dispatch('SHOW_HIDE_FOREIGN_USER_SEARCH')
    },
    setForeignUser (val) {
      this.$store.dispatch('SET_FOREIGN_USER', val.id)
      this.dialogFormVisible = true
    },
    searchForeignUsers () {
      // let surnameToSearch = this.searchSurname
      if (this.searchSurname.length >= 2 || this.searchSurname.length === 0) {
        this.$store.dispatch('LOAD_SEARCHED_FOREIGN_USERS', {surname: this.searchSurname})
      } else {
        this.$notify.warning({
          title: 'Προειδοποίηση',
          message: 'Εισάγετε τουλάχιστον 2 γράμματα από το επώνυμο',
          offset: 300
        })
        // this.$store.dispatch('LOAD_SEARCHED_FOREIGN_USERS', {surname: ''})
      }
    }
  },
  computed: {
    tableData () {
      if (this.searchedForeignUsers !== undefined && this.searchedForeignUsers !== null) {
        return this.searchedForeignUsers.map(fUser => {
          return {
            id: fUser.id,
            name: fUser.name,
            surname: fUser.surname,
            fatherName: fUser.fatherName,
            motherName: fUser.motherName
          }
        })
      } else {
        return []
      }
    },
    userCredentials () {
      return (this.searchedForeigner !== undefined && this.searchedForeigner !== null)
        ? {name: this.searchedForeigner.firstname,
          email: this.searchedForeigner.email,
          surname: this.searchedForeigner.surname,
          fatherName: this.searchedForeigner.fathers_name,
          motherName: this.searchedForeigner.mothers_name,
          mobile: this.searchedForeigner.mobile_phone,
          id: this.searchedForeigner.id,
          foreignerId: {number: this.searchedForeigner.foreigner_id_num, country: this.searchedForeigner.foreigner_id_country} }
        : {
          name: '',
          email: '',
          surname: '',
          fatherName: '',
          motherName: '',
          dateOfBirth: '',
          foreignerId: { number: '', country: '' }
        }
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'searchedForeigner',
      'searchedForeignUsers',
      'showSearchedApplication',
      'showSearchedForeignUser',
      'loadingSearchedApplication',
      'loadingSearchedApplications',
      'searchedAppHistory',
      'BASE_URL'
    ])
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .el-input {
    width: 200px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ForeignUserSearch.vue